(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["digital-product-consent"] && !Shopify.designMode) return;
  try {
    function initializeDigitalProductConsent(root = document) {
    root.querySelectorAll('[data-digital-product-consent]').forEach((consent) => {
      if (consent.dataset.initialized === 'true') return;

      const checkbox = consent.querySelector('input[type="checkbox"]');
      const form = consent.closest('form');
      const acceleratedCheckout = form?.querySelector('.accelerated-checkout-block');

      if (!checkbox || !form) return;

      consent.dataset.initialized = 'true';

      const updateState = () => {
        const accepted = checkbox.checked;
        form.classList.toggle('digital-consent-pending', !accepted);
        acceleratedCheckout?.toggleAttribute('inert', !accepted);
        acceleratedCheckout?.setAttribute('aria-disabled', accepted ? 'false' : 'true');
      };

      checkbox.addEventListener('change', updateState);
      form.addEventListener('submit', (event) => {
        if (checkbox.checked) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        checkbox.reportValidity();
        checkbox.focus({ preventScroll: true });
        consent.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);

      updateState();
    });
  }

  initializeDigitalProductConsent();
  document.addEventListener('shopify:section:load', (event) => initializeDigitalProductConsent(event.target));
  document.addEventListener('shopify:section:select', (event) => initializeDigitalProductConsent(event.target));
  new MutationObserver(() => initializeDigitalProductConsent()).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  } catch(e) { console.error(e); }
})();

})();
